import React, { Fragment, useEffect, useState } from "react";
// import baseUrl from "../../utils/baseUrl";
import {
	Button,
	Col,
	DatePicker,
	Form,
	Input,
	Row,
	Select,
	Typography,
	TimePicker,
    Image, Tag 
} from "antd";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import {
	clearProject,
	loadAllProject,
	updateProject,
	loadSingleProject,
} from "../../redux/rtk/features/projectManagement/project/project/project";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import PageTitle from "../page-header/PageHeader";
import Loader from "../loader/loader";
import baseUrl from "../../utils/baseUrl";

const UpdateProject = ({ drawer }) => {
	const projectId = useParams("id").projectId;
	const [loader, setLoader] = useState(false);
	const userList = useSelector((state) => state.users.list);
	const { loading, project } = useSelector((state) => state.project);

	const dispatch = useDispatch();
	const { Title } = Typography;
	const [form] = Form.useForm();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(loadSingleProject(projectId));
		dispatch(loadAllStaff({ status: "true" }));
		return () => {
			dispatch(clearProject());
		};
	}, []);

	useEffect(() => {
		if (project) {
			const parsedStartDate = project.startDate
				? moment(project.startDate)
				: null;

			const parsedStartTime = project.startTime
				? moment(project.startTime, "HH:mm")
				: null;

			form.setFieldsValue({
				...project,
				startDate: parsedStartDate,
				startTime: parsedStartTime,
			});
		}
	}, [project]);

	const onFinish = async (values) => {
		try {
			const projectData = {
				...values,
				startDate: values.startDate?.format("YYYY-MM-DD") || null,
				startTime: values.startTime?.format("HH:mm") || null,
			};

			setLoader(true);

			const resp = await dispatch(
				updateProject({ id: projectId, values: projectData })
			);

			if (resp.payload.message === "success") {
				form.resetFields();
				dispatch(loadAllProject());
				navigate(-1);
			}
		} catch (error) {
			console.error("Update project error:", error);
		} finally {
			setLoader(false);
		}
	};

	const onFinishFailed = () => {
		toast.warning("Failed at updating Project");
		setLoader(false);
	};

	return (
		<Fragment>
			<PageTitle title={"Back"} />
			<Row className='mr-top' justify={drawer ? "center" : "center"}>
				<Col
					xs={24}
					sm={24}
					md={24}
					lg={drawer ? 22 : 18}
					xl={drawer ? 22 : 16}
					className='column-design border rounded card-custom'>
					<Title level={4} className='m-2 mt-5 mb-5 text-center'>
						Update Project
					</Title>
					{project ? (
						<Form
							form={form}
							style={{ marginBottom: "40px" }}
							name='update-project-form'
							labelCol={{ span: 8 }}
							wrapperCol={{ span: 12 }}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
                                <Form.Item
								label='Customer'
								name='requesterId'
								rules={[{ required: true, message: "Select Customer" }]}>
								<Select
									loading={!userList.length}
									showSearch
									placeholder='Select Customer'
									optionFilterProp='children'>
									{userList.map((item) => (
										<Select.Option key={item.id} value={item.id}>
											{item.firstName} {item.lastName}
										</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Form.Item
								label='Service Man'
								name='projectManagerId'
								rules={[{ required: true, message: "Select Service Man" }]}>
								<Select
									loading={!userList.length}
									showSearch
									placeholder='Select Service Man'
									optionFilterProp='children'>
									{userList.map((item) => (
										<Select.Option key={item.id} value={item.id}>
											{item.firstName} {item.lastName}
										</Select.Option>
									))}
								</Select>
							</Form.Item>

							<Form.Item
								label='Task Name'
								name='name'
								rules={[{ required: true, message: "Enter Task Name" }]}>
								<Input placeholder='Enter Task Name' />
							</Form.Item>
                            <Form.Item
  label="Task Image"
  shouldUpdate
>
  {() => {
    const image = form.getFieldValue("image");
    return image ? (
      <Image
        src={`${baseUrl}/files/${image}`}
        width={80}
        height={80}
        style={{ objectFit: "cover", borderRadius: "8px" }}
        preview={{
          mask: <span style={{ fontSize: 13 }}>View Image</span>,
        }}
      />
    ) : (
      <Tag color="default">No Image</Tag>
    );
  }}
</Form.Item>


							<Form.Item
								label='Start Date'
								name='startDate'
								rules={[{ required: true, message: "Please input Start Date!" }]}>
								<DatePicker />
							</Form.Item>

							<Form.Item
								label='Start Time'
								name='startTime'
								rules={[{  message: "Please input Start Time!" }]}>
								<TimePicker format='HH:mm' />
							</Form.Item>

							<Form.Item
								label='Project Description'
								name='description'
								rules={[{ required: true, message: "Enter Project Description" }]}>
								<Input.TextArea placeholder='Enter Project Description' />
							</Form.Item>
                            <Form.Item label="Custom Offer?" shouldUpdate>
  {() => <span>{form.getFieldValue("isCustomOffer") ? "Yes" : "No"}</span>}
</Form.Item>
                            <Form.Item
								label='Hourly Rate(€)'
								name='offerValue'
								rules={[{ required: true, message: "Enter Hourly Rate" }]}>
								<Input placeholder='Update Hourly Rate' />
							</Form.Item>

							<Form.Item wrapperCol={{ offset: 8, span: 12 }}>
								<Button
									type='primary'
									size='large'
									htmlType='submit'
									block
									loading={loader}>
									Update Project
								</Button>
							</Form.Item>
						</Form>
					) : (
						<Loader />
					)}
				</Col>
			</Row>
		</Fragment>
	);
};

export default UpdateProject;
